import { CommandingReply } from "@/backend/express/controllers/commandingController";
import { Client } from "./client";
import { CommandingParams } from "@/backend/models/commanding";

export class CommandingController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async updateCommanding(req: CommandingParams): Promise<CommandingReply> {
    return this.client.update('/api/commandings', req);
  }
}